import {DataObjectId, Hub, StickerType} from 'yougile-model'
import {sortByCustomSticker, sortByStickerName} from './sort-by-custom-sticker'
import {sortByDeadlineNew, sortByDeadlineOld} from './sort-by-deadline'
import {sortByDoneCompleted, sortByDoneUnfulfilled} from './sort-by-done'
import {sortByExecutorAz, sortByExecutorZa} from './sort-by-executor'
import {
  sortByTimeInColumnNew,
  sortByTimeInColumnOld
} from './sort-by-time-in-column'
import {OrderSubMenuActionType, OrderSubMenuType} from './types'

interface Props {
  tasks: Hub[]
  subMenu: OrderSubMenuType
  action: OrderSubMenuActionType
  column: Hub
  stickerId?: DataObjectId
  stickerType?: StickerType
}

export const columnSort = (props: Props): Hub[] => {
  const {
    tasks: origTasks,
    subMenu,
    action,
    column,
    stickerId,
    stickerType
  } = props
  const tasks = [...origTasks]

  ///

  if (subMenu === 'taskName' && action === 'az') {
    return sortByTaskNameAz(tasks)
  }

  if (subMenu === 'taskName' && action === 'za') {
    return sortByTaskNameZa(tasks)
  }

  ///

  if (subMenu === 'dateCreation' && action === 'new') {
    return sortByCreationNew(tasks)
  }

  if (subMenu === 'dateCreation' && action === 'old') {
    return sortByCreationOld(tasks)
  }

  ///

  if (subMenu === 'done' && action === 'completed') {
    return sortByDoneCompleted(tasks)
  }

  if (subMenu === 'done' && action === 'unfulfilled') {
    return sortByDoneUnfulfilled(tasks)
  }

  ///

  if (subMenu === 'executor' && action === 'za') {
    return sortByExecutorZa(tasks, column)
  }

  if (subMenu === 'executor' && action === 'az') {
    return sortByExecutorAz(tasks, column)
  }

  ///

  if (subMenu === 'deadline' && action === 'old') {
    return sortByDeadlineOld(tasks)
  }

  if (subMenu === 'deadline' && action === 'new') {
    return sortByDeadlineNew(tasks)
  }

  if (subMenu === 'customSticker' && stickerId) {
    return sortByCustomSticker(
      tasks,
      action,
      stickerId,
      stickerType === 'numeric'
    )
  }

  if (subMenu === 'textCustomSticker' && stickerId) {
    return sortByStickerName(tasks, action, stickerId)
  }

  ///

  if (subMenu === 'timeInColumn' && action === 'old') {
    return sortByTimeInColumnOld(tasks)
  }

  if (subMenu === 'timeInColumn' && action === 'new') {
    return sortByTimeInColumnNew(tasks)
  }

  return origTasks
}

const sortByTaskNameAz = (tasks: Hub[]): Hub[] => {
  return tasks.sort((a, b) => (a.title || '').localeCompare(b.title || ''))
}

const sortByTaskNameZa = (tasks: Hub[]): Hub[] => {
  return tasks.sort((a, b) => (b.title || '').localeCompare(a.title || ''))
}

const sortByCreationNew = (tasks: Hub[]): Hub[] => {
  return tasks.sort((a, b) => b.timestamp - a.timestamp)
}

const sortByCreationOld = (tasks: Hub[]): Hub[] => {
  return tasks.sort((a, b) => a.timestamp - b.timestamp)
}
